import { MSMRequest } from "../../../../api/msm";
import PopupText from "../../../PopupText";
import Text from "../../../Text";
import * as ConsulenzaGratuitaStyles from "./consulenza-gratuita.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import classNames from "classnames";
import parse from "html-react-parser";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { IMaskInput } from "react-imask";
import { useSelector } from "react-redux";
import * as yup from "yup"
import {
  getGclid,
  getMsmlid,
  getQueryStringValues,
  getUtmChatbot,
  getLastMethodLid,
  getUtmSource,
  getUtmCampaign,
  getUtmMedium,
  getMsclkid,
} from "../../../../state/selectors/config.selector";

function ConsulenzaGratuita({ labelCta, consenso, setSettingsModal, formChatbot, chatMutuoUid }) {
  const schemaConsulenzaGratuita = yup.object().shape(
    {
      Nome: yup
        .string()
        .min(2, 'Il campo "Nome" deve contenere almeno 2 caratteri')
        .trim()
        .required('Il campo "Nome" è obbligatorio')
        .matches(/^[aA-zZ\s]+$/, 'Il campo "Nome" può contenere solo lettere'),
      Cognome: yup
        .string()
        .min(2, 'Il campo "Cognome" deve contenere almeno 2 caratteri')
        .trim()
        .required('Il campo "Cognome" è obbligatorio')
        .matches(
          /^[aA-zZ\s]+$/,
          'Il campo "Cognome" può contenere solo lettere'
        ),
      Telefono01: yup
        .string()
        .required('Il campo "Telefono" è obbligatorio')
        .matches(
          /^(?:\+39)?\d{9,10}$/,
          'Il campo "Telefono" deve avere un numero valido'
        ),
      // Telefono02: yup.string().when("Telefono02", {
      //   is: (value) => value?.length > 0,
      //   then: yup
      //     .string()
      //     .matches(
      //       /^(?:\+39)?\d{9,10}$/,
      //       'Il campo "2° Telefono" deve essere un numero valido'
      //     ),
      //   otherwise: yup.string().nullable().optional(),
      // }),
      Email: yup
        .string()
        .email('Il campo "Email" deve essere un indirizzo valido')
        .required('Il campo "Email" è obbligatorio'),
      Note: yup.string().nullable().optional(),
      privacy: yup
        .boolean()
        .oneOf(
          [true],
          "Devi accettare la privacy policy per inviare il modulo"
        ),
    },
    [["Telefono01", "Telefono01"]]
  );
  const QueryStringValues = useSelector(getQueryStringValues);
  const gclid = useSelector(getGclid);
  const msmlid = useSelector(getMsmlid);
  const utmchatbot = useSelector(getUtmChatbot);
  const lastMethodLid = useSelector(getLastMethodLid);
  const utmSource = useSelector(getUtmSource);
  const utmCampaign = useSelector(getUtmCampaign);
  const utmMedium = useSelector(getUtmMedium);
  const msclkid = useSelector(getMsclkid);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    control,
    watch,
    reset,
  } = useForm({
    resolver: yupResolver(schemaConsulenzaGratuita),
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      Nome: "",
      Cognome: "",
      Email: "",
      Telefono01: "",
      Note: "",
      CodiceOriginator: 1,
      gclid: gclid, // Google Click ID
      msmlid: msmlid, // MSM Lead ID
      utm_source: utmSource, // UTM Source
      utm_campaign: utmCampaign, // UTM Campaign
      utm_medium: utmMedium, // UTM Medium
      lastMethodLid: lastMethodLid, // Last Method Lead ID
      utm_chatbot: formChatbot, // UTM Chatbot
      msclkid: msclkid, // Microsoft Click Id
      chatMutuoUid: chatMutuoUid,
      QueryStringValues: {
        // Query String Values
        ...QueryStringValues,
      }
}});

  const watchs = watch();

  const onSubmit = async (data) => {
    const response = await MSMRequest("FattiChiamare", data);
    if (response.success) {
      const BodyContent = (
        <Text content="Il messaggio è stato inviato con successo. A breve sarai contattato da un nostro consulente." />
      );
      setSettingsModal({
        title: "Grazie",
        content: BodyContent,
      });
      reset();
    } else {
      const BodyContent = (
        <Text content="Si è verificato un errore. Riprova più tardi." />
      );
      setSettingsModal({
        title: "Attenzione",
        content: BodyContent,
      });
    }
  };

  const onError = (errors, e) => {
    const BodyContent = (
      <>
        {Object.keys(errors).map((key, index) => {
          return <p key={index}>{errors[key].message}</p>;
        })}
      </>
    );
    setSettingsModal({
      title: "Attenzione",
      content: BodyContent,
    });
  };

  return (
    <Form className={ConsulenzaGratuitaStyles.form} autoComplete="off">
      <Row className={ConsulenzaGratuitaStyles.formRow}>
        <Col md={6}>
          <div
            className={classNames(ConsulenzaGratuitaStyles.field, {
              [ConsulenzaGratuitaStyles.fieldError]: errors.Nome,
              [ConsulenzaGratuitaStyles.fieldValid]:
                !errors.Nome && watchs.Nome?.length > 0,
            })}
          >
            <label
              htmlFor="Nome"
              className={classNames({
                [ConsulenzaGratuitaStyles.filled]: watchs.Nome?.length > 0,
              })}
            >
              Nome*
            </label>
            <input type="text" {...register("Nome")} />
          </div>
        </Col>
        <Col md={6}>
          <div
            className={classNames(ConsulenzaGratuitaStyles.field, {
              [ConsulenzaGratuitaStyles.fieldError]: errors.Cognome,
              [ConsulenzaGratuitaStyles.fieldValid]:
                !errors.Cognome && watchs.Cognome?.length > 0,
            })}
          >
            <label
              htmlFor="Cognome"
              className={classNames({
                [ConsulenzaGratuitaStyles.filled]: watchs.Cognome?.length > 0,
              })}
            >
              Cognome*
            </label>
            <input type="text" {...register("Cognome")} />
          </div>
        </Col>
        <Col md={6}>
          <div
            className={classNames(ConsulenzaGratuitaStyles.field, {
              [ConsulenzaGratuitaStyles.fieldError]: errors.Telefono01,
              [ConsulenzaGratuitaStyles.fieldValid]:
                !errors.Telefono01 && watchs.Telefono01?.length > 0,
            })}
          >
            <label
              htmlFor="Telefono01"
              className={classNames({
                [ConsulenzaGratuitaStyles.filled]:
                  watchs.Telefono01?.length > 0,
              })}
            >
              Telefono*
            </label>
            <Controller
              name="Telefono01"
              control={control}
              valueAsNumber={true}
              render={({ field }) => (
                <IMaskInput
                  mask={Number}
                  unmask={true}
                  onAccept={(value, mask) => {
                    field.onChange(value);
                  }}
                />
              )}
            />
          </div>
        </Col>
        <Col md={6}>
          <div
            className={classNames(ConsulenzaGratuitaStyles.field, {
              [ConsulenzaGratuitaStyles.fieldError]: errors.Email,
              [ConsulenzaGratuitaStyles.fieldValid]:
                !errors.Email && watchs.Email?.length > 0,
            })}
          >
            <label
              htmlFor="Email"
              className={classNames({
                [ConsulenzaGratuitaStyles.filled]: watchs.Email?.length > 0,
              })}
            >
              E-mail*
            </label>
            <input type="email" {...register("Email")} />
          </div>
        </Col>
        {/* <Col md={12}>
          <div className={ConsulenzaGratuitaStyles.field}>
            <textarea {...register("Note")} placeholder="Messaggio" />
          </div>
        </Col> */}
        <Col md={12} lg={8}>
          <div
            className={classNames(ConsulenzaGratuitaStyles.fieldCheckbox, {
              [ConsulenzaGratuitaStyles.fieldError]: errors?.privacy,
            })}
          >
            <input type="checkbox" {...register("privacy")} />
            <label htmlFor="privacy">
              {parse(consenso.label, {
                replace: (domNode) => {
                  if (
                    domNode.attribs &&
                    domNode.attribs["data-config"] &&
                    domNode.attribs["data-config"].length > 0
                  ) {
                    const dataConfigParsed = JSON.parse(
                      domNode.attribs["data-config"]
                    );
                    switch (dataConfigParsed.type) {
                      case "open-popup":
                        return (
                          <button
                            className={ConsulenzaGratuitaStyles.trigger}
                            onClick={(e) => {
                              e.preventDefault();
                              const BodyContent = (
                                <>
                                  <PopupText content={consenso.popup.testo} />
                                </>
                              );
                              setSettingsModal({
                                title: consenso.popup.titolo,
                                content: BodyContent,
                                size: "xl",
                              });
                            }}
                          >
                            {dataConfigParsed.label}
                          </button>
                        );
                      default:
                        break;
                    }
                  }
                },
              })}
            </label>
          </div>
        </Col>
        <Col md={12} lg={4}>
          <button
            type="submit"
            onClick={handleSubmit(onSubmit, onError)}
            className={ConsulenzaGratuitaStyles.button}
            disabled={isSubmitting}
          >
            {labelCta}
          </button>
        </Col>
      </Row>
    </Form>
  );
}

export default ConsulenzaGratuita;
